import type { ProductNearToMaturity } from 'apiConnector/discover/lifeCycle';
import {
  LifeCycleItemProps,
  LifeCycleSectionContainer,
  lifeCycleApi,
} from 'components/discover/post-trade/life-cycle/section-container';
import { Section } from 'components/discover/post-trade/life-cycle/section/section-content';

import 'components/discover/post-trade/life-cycle/index.css';
import { FormattedMessage } from 'react-intl';

export function NearToMaturitySection(props: LifeCycleItemProps) {
  return (
    <LifeCycleSectionContainer title="nearToMaturity" fetchData={lifeCycleApi.fetchNearToMaturity} {...props}>
      {(product: ProductNearToMaturity) => (
        <>
          <Section.Badge className="border-0 badge-discreet-secondary">
            {product.daysToMaturity}{' '}
            <FormattedMessage id="discover.lifeCycle.days" values={{ itemCount: product.daysToMaturity }} />
          </Section.Badge>
        </>
      )}
    </LifeCycleSectionContainer>
  );
}
